module.exports = __webpack_public_path__ + "static/media/NFSB01.83547229.jpg";